"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
function FieldRuleFromJSON(json) {
    return FieldRuleFromJSONTyped(json, false);
}
exports.FieldRuleFromJSON = FieldRuleFromJSON;
function FieldRuleFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'field': !runtime_1.exists(json, 'field') ? undefined : json['field'],
        'equals': !runtime_1.exists(json, 'equals') ? undefined : json['equals'],
        'notEquals': !runtime_1.exists(json, 'not-equals') ? undefined : json['not-equals'],
        'and': !runtime_1.exists(json, 'and') ? undefined : (json['and'].map(FieldRuleFromJSON)),
        'or': !runtime_1.exists(json, 'or') ? undefined : (json['or'].map(FieldRuleFromJSON)),
    };
}
exports.FieldRuleFromJSONTyped = FieldRuleFromJSONTyped;
function FieldRuleToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'field': value.field,
        'equals': value.equals,
        'not-equals': value.notEquals,
        'and': value.and === undefined ? undefined : (value.and.map(FieldRuleToJSON)),
        'or': value.or === undefined ? undefined : (value.or.map(FieldRuleToJSON)),
    };
}
exports.FieldRuleToJSON = FieldRuleToJSON;
//# sourceMappingURL=data:application/json;base64,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